module.exports = __webpack_public_path__ + "img/resource-tech-image-44.d3f6be55.jpg";